import { useEffect } from "react";
import { leadSubmissionApi } from "../services/leadSubmissionApi";

const WindowWarning = (props) => {
    useEffect(() => {
        const unloadCallback = (event) => {
            event.preventDefault();
            
            //Submit Lead if user close out of page (back, refresh, close tab/window)
            if (props.submitLead) {
                try {
                    postLeadThruApi(props);
                }
                catch (err){
                    console.error(err);
                }                
            }

            event.returnValue = "";
            return "";
        };

        window.addEventListener("beforeunload", unloadCallback);
        return () => window.removeEventListener("beforeunload", unloadCallback);
    }, []);
    return (null);
}

function postLeadThruApi(props) {
    //Submit Lead    
    const leadSubmissionService = new leadSubmissionApi(props, props.handleLeadSubmission);

    leadSubmissionService.submitLead(false).then((leadSuccess) => {
        if (leadSuccess) {
            console.log("Lead Success");
        }
        else {
            console.log("Lead Failed");
        }
    });
}

export default WindowWarning;